import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, InputSignal, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StringUtils } from '@app/core/utils/string.utils';
@Component({
  selector: 'footer-widget',
  imports: [CommonModule, FormsModule, NgOptimizedImage],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
})
export class FooterComponent {
  @Input() actionEvent: (event: any) => void;
  allSlotsData: InputSignal<any> = input.required();
  emailSubscribed: boolean = false;
  subscriptionMsg: string;
  email: string = '';
  footerPoint = signal([
    'Monotaro (Japan)',
    'Navimro (Korea)',
    'Monotaro (Indonesia)'
  ]);

  ngOnInit() {
    
  }

  subscribeNewsLetter() {
    this.emailSubscribed = true;
    if (StringUtils.isValidEmail(this.email)) {
      this.subscriptionMsg = 'Email subscribed successfully!';
    } else {
      this.subscriptionMsg = 'Please enter a valid email.';
    }
  }

  actionPerform(actionData: any = {}) {
    this.actionEvent({
      actionData,
    });
  }
}
